"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var smtpAddress_1 = require("../utils/smtpAddress");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var FocusZone_1 = require("office-ui-fabric-react/lib/FocusZone");
var List_1 = require("office-ui-fabric-react/lib/List");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var TextField_1 = require("office-ui-fabric-react/lib/TextField");
var owa_assert_1 = require("owa-assert");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var owa_trace_1 = require("owa-trace");
var React = require("react");
var Selection_1 = require("office-ui-fabric-react/lib/Selection");
var KeyboardCharCodes_1 = require("owa-mail-hotkeys/lib/utils/KeyboardCharCodes");
var styles = require('./EditSendersAndDomains.scss');
var classNames = require('classnames/bind');
var EditSendersAndDomainsMode;
(function (EditSendersAndDomainsMode) {
    EditSendersAndDomainsMode[EditSendersAndDomainsMode["EmailAddressOnly"] = 0] = "EmailAddressOnly";
    EditSendersAndDomainsMode[EditSendersAndDomainsMode["DomainOnly"] = 1] = "DomainOnly";
    EditSendersAndDomainsMode[EditSendersAndDomainsMode["EmailAddressAndDomain"] = 2] = "EmailAddressAndDomain";
})(EditSendersAndDomainsMode = exports.EditSendersAndDomainsMode || (exports.EditSendersAndDomainsMode = {}));
var ValidationResult;
(function (ValidationResult) {
    ValidationResult[ValidationResult["OK"] = 0] = "OK";
    ValidationResult[ValidationResult["InvalidAddress"] = 1] = "InvalidAddress";
    ValidationResult[ValidationResult["InvalidAddressOrDomain"] = 2] = "InvalidAddressOrDomain";
    ValidationResult[ValidationResult["InvalidDomain"] = 3] = "InvalidDomain";
    ValidationResult[ValidationResult["IsSelf"] = 4] = "IsSelf";
})(ValidationResult || (ValidationResult = {}));
var EditSendersAndDomains = /** @class */ (function (_super) {
    tslib_1.__extends(EditSendersAndDomains, _super);
    function EditSendersAndDomains() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.editItemState = null;
        _this.newItemState = { errorMessage: null, value: null };
        _this.selection = null;
        _this.renderListItem = function (item, index) {
            var isEdit = _this.editItemState && _this.editItemState.index === index;
            var isSelected = _this.selection.isIndexSelected(index);
            return (React.createElement("div", { "data-selection-index": index, key: index, "data-is-focusable": !isEdit, "data-selection-disabled": isEdit }, isEdit
                ? _this.renderEditListItem(item, index)
                : _this.renderViewListItem(item, index, isSelected)));
        };
        _this.renderViewListItem = function (item, index, isSelected) {
            var itemClassName = classNames(styles.viewListItemCell, isSelected && styles.viewListItemCellSelected);
            return (React.createElement("div", { className: itemClassName, "data-is-focusable": true, key: index, onKeyDown: _this.onViewListItemTextFieldKeyDown }, item.key));
        };
        _this.renderEditListItem = function (item, index) {
            _this.selection.setChangeEvents(false);
            return (React.createElement("div", { key: index, "data-is-focusable": false },
                React.createElement(TextField_1.TextField, { "data-is-focusable": false, className: styles.textField, onBlur: function () { return _this.onEditItemTextFieldBlur(index); }, onChanged: _this.onEditItemTextFieldChanged, onFocus: _this.moveEditItemTextFieldCaretToEnd, onKeyDown: function (event) { return _this.onEditItemTextFieldKeyDown(event, index); }, ref: function (input) {
                        input && _this.shouldSetFocusInEditListItemTextField() && input.focus();
                    }, value: _this.editItemState.value }),
                _this.editItemState.errorMessage && (React.createElement(MessageBar_1.MessageBar, { isMultiline: false, messageBarType: MessageBar_1.MessageBarType.error }, _this.editItemState.errorMessage))));
        };
        _this.onAddNewItemButtonClicked = function () {
            if (_this.isDuplicate(_this.newItemState.value)) {
                _this.newItemState.value = '';
                return;
            }
            var result = _this.validateSenderOrDomain(_this.newItemState.value);
            if (result == 0 /* OK */) {
                var sendersAndDomains = _this.props.items.slice(0);
                sendersAndDomains.unshift(_this.newItemState.value.trim());
                _this.props.onItemsChanged(sendersAndDomains);
                _this.newItemState.value = '';
            }
            else {
                _this.setNewItemTextFieldErrorMessage(_this.validationErrorMessage(result));
            }
        };
        _this.onEditItemTextFieldBlur = function (index) {
            var result = _this.validateSenderOrDomain(_this.editItemState.value);
            if (result == 0 /* OK */) {
                var sendersAndDomains = _this.props.items.slice(0);
                sendersAndDomains.splice(index, 1, _this.editItemState.value.trim());
                _this.props.onItemsChanged(sendersAndDomains);
                _this.editItemState = null;
                _this.selection = null;
            }
            else {
                _this.setEditItemTextFieldErrorMessage(_this.validationErrorMessage(result));
            }
        };
        _this.resetSelectionOnNextRender = function () {
            _this.selection = null;
        };
        _this.resetSelection = function (items) {
            _this.selection = new Selection_1.Selection({
                onSelectionChanged: function () {
                    if (_this.hasMounted) {
                        _this.forceUpdate();
                    }
                },
                getKey: function (item, index) { return index.toString(); },
            });
            var itemsWithKey = items.map(function (item) {
                return { key: item };
            });
            _this.selection.setItems(itemsWithKey, false);
        };
        _this.onEditItemTextFieldChanged = function (newValue) {
            _this.clearEditItemTextFieldErrorMessage();
            _this.editItemState.value = newValue;
        };
        _this.onEditItemTextFieldKeyDown = function (event, index) {
            switch (event.keyCode) {
                case KeyboardCharCodes_1.ENTER_CHARCODE:
                    var result = _this.validateSenderOrDomain(_this.editItemState.value);
                    if (result == 0 /* OK */) {
                        var sendersAndDomains = _this.props.items.slice(0);
                        sendersAndDomains.splice(index, 1, _this.editItemState.value.trim());
                        _this.props.onItemsChanged(sendersAndDomains);
                        _this.editItemState = null;
                        _this.resetSelectionOnNextRender();
                    }
                    else {
                        _this.setEditItemTextFieldErrorMessage(_this.validationErrorMessage(result));
                    }
                    break;
                case KeyboardCharCodes_1.ESC_CHARCODE:
                    event.stopPropagation();
                    _this.editItemState = null;
                    _this.resetSelectionOnNextRender();
                    break;
                default:
                    break;
            }
        };
        _this.onEditListItemButtonClicked = function () {
            if (_this.selection.count != 1) {
                throw new Error('onEditListItemButtonClicked with selected items count != 1');
            }
            var item = _this.selection.getItems()[0];
            var index = _this.props.items.indexOf(item.key);
            _this.editItemState = {
                value: item.key,
                index: index,
                errorMessage: null,
            };
        };
        _this.onDeleteListItemButtonClicked = function () {
            var sendersAndDomains = _this.props.items.slice(0);
            _this.selection.getSelection().forEach(function (item) {
                var index = sendersAndDomains.indexOf(item.key);
                if (index !== -1) {
                    sendersAndDomains.splice(index, 1);
                }
            });
            _this.props.onItemsChanged(sendersAndDomains);
            _this.resetSelectionOnNextRender();
        };
        _this.onItemInvoked = function (invokedItem) {
            if ((_this.editItemState && _this.editItemState.errorMessage) ||
                _this.newItemState.errorMessage) {
                return;
            }
            var index = _this.props.items.indexOf(invokedItem.key);
            if (index !== -1) {
                _this.selection.setAllSelected(false);
                _this.editItemState = {
                    value: invokedItem.key,
                    index: index,
                    errorMessage: null,
                };
            }
        };
        _this.onNewItemTextFieldChanged = function (text) {
            _this.clearNewItemTextFieldErrorMessage();
            _this.newItemState.value = text;
        };
        _this.onNewItemTextFieldFocus = function () {
            _this.selection.setAllSelected(false);
        };
        _this.onNewItemTextFieldKeyDown = function (event) {
            switch (event.keyCode) {
                case KeyboardCharCodes_1.ENTER_CHARCODE:
                    if (_this.newItemState.value && _this.newItemState.value.length > 0) {
                        var result = _this.validateSenderOrDomain(_this.newItemState.value);
                        if (result == 0 /* OK */) {
                            _this.onAddNewItemButtonClicked();
                        }
                        else {
                            _this.setNewItemTextFieldErrorMessage(_this.validationErrorMessage(result));
                        }
                    }
                    break;
                case KeyboardCharCodes_1.ESC_CHARCODE:
                    event.stopPropagation();
                    break;
                default:
                    break;
            }
        };
        _this.onViewListItemTextFieldKeyDown = function (event) {
            switch (event.keyCode) {
                case KeyboardCharCodes_1.BACKSPACE_CHARCODE:
                case KeyboardCharCodes_1.DELETE_CHARCODE:
                    _this.onDeleteListItemButtonClicked();
                    break;
                default:
                    break;
            }
        };
        _this.moveEditItemTextFieldCaretToEnd = function (event) {
            var tempValue = event.target.value;
            event.target.value = '';
            event.target.value = tempValue;
        };
        _this.newItemTextFieldPlaceHolderText = function () {
            switch (_this.props.mode) {
                case 1 /* DomainOnly */:
                    return owa_options_strings_1.default.options_common_addDomainPlaceholder;
                case 2 /* EmailAddressAndDomain */:
                    return owa_options_strings_1.default.options_common_addSenderOrDomainPlaceholder;
                case 0 /* EmailAddressOnly */:
                    return owa_options_strings_1.default.options_common_addSenderPlaceholder;
                default:
                    return owa_assert_1.assertNever(_this.props.mode);
            }
        };
        _this.isSelf = function (smtpAddress) {
            var sessionSettings = getUserConfiguration_1.default().SessionSettings;
            var userEmailAddress = sessionSettings.UserEmailAddress;
            var lowerCaseSmtpAddress = smtpAddress.toLowerCase();
            if (!userEmailAddress) {
                owa_trace_1.trace.error('User email address from session data is null.');
            }
            return (userEmailAddress.toLowerCase() === lowerCaseSmtpAddress ||
                (sessionSettings.UserProxyAddresses &&
                    sessionSettings.UserProxyAddresses.some(function (address) { return address.toLowerCase() === lowerCaseSmtpAddress; })));
        };
        _this.setEditItemTextFieldErrorMessage = function (message) {
            _this.editItemState.errorMessage = message;
            _this.forceUpdate();
        };
        _this.setNewItemTextFieldErrorMessage = function (message) {
            _this.newItemState.errorMessage = message;
        };
        _this.clearEditItemTextFieldErrorMessage = function () {
            _this.editItemState.errorMessage = null;
            _this.forceUpdate();
        };
        _this.clearNewItemTextFieldErrorMessage = function () {
            _this.newItemState.errorMessage = null;
        };
        _this.validateSenderOrDomain = function (text) {
            var trimmedText = text.trim();
            switch (_this.props.mode) {
                case 1 /* DomainOnly */:
                    return _this.validateDomain(trimmedText);
                case 0 /* EmailAddressOnly */:
                    return _this.validateEmailAddress(trimmedText);
                case 2 /* EmailAddressAndDomain */:
                    if (_this.validateEmailAddress(trimmedText) == 0 /* OK */ ||
                        _this.validateDomain(trimmedText) == 0 /* OK */) {
                        return 0 /* OK */;
                    }
                    else {
                        return 2 /* InvalidAddressOrDomain */;
                    }
                default:
                    return owa_assert_1.assertNever(_this.props.mode);
            }
        };
        _this.validateEmailAddress = function (text) {
            if (_this.isSelf(text)) {
                return 4 /* IsSelf */;
            }
            return smtpAddress_1.isValidAddress(text) ? 0 /* OK */ : 1 /* InvalidAddress */;
        };
        _this.validateDomain = function (text) {
            return smtpAddress_1.isValidAddressDomain(text) ? 0 /* OK */ : 3 /* InvalidDomain */;
        };
        _this.validationErrorMessage = function (result) {
            switch (result) {
                case 0 /* OK */:
                    throw new Error('validationErrorMessage called for OK');
                case 1 /* InvalidAddress */:
                    return owa_options_strings_1.default.options_common_invalidAddressError;
                case 2 /* InvalidAddressOrDomain */:
                    return owa_options_strings_1.default.options_common_invalidAddressOrDomainError;
                case 3 /* InvalidDomain */:
                    return owa_options_strings_1.default.options_common_invalidDomainError;
                case 4 /* IsSelf */:
                    return owa_options_strings_1.default.options_common_invalidIsSelfError;
                default:
                    return owa_assert_1.assertNever(result);
            }
        };
        return _this;
    }
    EditSendersAndDomains.prototype.componentWillMount = function () {
        this.resetSelection(this.props.items);
    };
    EditSendersAndDomains.prototype.componentDidMount = function () {
        this.hasMounted = true;
    };
    EditSendersAndDomains.prototype.componentWillUpdate = function (nextProps, nextState) {
        if (!this.selection) {
            this.resetSelection(nextProps.items);
        }
    };
    EditSendersAndDomains.prototype.render = function () {
        var itemsWithKey = this.props.items.map(function (item) {
            return { key: item };
        });
        return (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(Button_1.IconButton, { className: styles.editListItemButton, "data-is-focusable": true, disabled: this.selection.count !== 1, iconProps: { iconName: "Edit" /* Edit */ }, onClick: this.onEditListItemButtonClicked, styles: {
                        rootDisabled: styles.disabledButton,
                    }, title: owa_options_strings_1.default.options_common_editEmailAddressOrDomainButtonTitle }),
                React.createElement(Button_1.IconButton, { className: styles.iconButton, "data-is-focusable": true, disabled: !this.selection.count || this.selection.count === 0, iconProps: { iconName: "Delete" /* Delete */ }, onClick: this.onDeleteListItemButtonClicked, styles: {
                        rootDisabled: styles.disabledButton,
                    }, title: owa_options_strings_1.default.options_common_removeEmailAddressOrDomainButtonTitle })),
            React.createElement("div", { className: styles.outerContainer },
                React.createElement("div", { className: styles.textFieldAndListContainer },
                    React.createElement("div", null,
                        React.createElement(TextField_1.TextField, { className: styles.textField, onChanged: this.onNewItemTextFieldChanged, onFocus: this.onNewItemTextFieldFocus, onKeyDown: this.onNewItemTextFieldKeyDown, placeholder: this.newItemTextFieldPlaceHolderText(), value: this.newItemState.value || '' })),
                    this.newItemState.errorMessage && (React.createElement(MessageBar_1.MessageBar, { isMultiline: false, messageBarType: MessageBar_1.MessageBarType.error, onDismiss: this.clearNewItemTextFieldErrorMessage }, this.newItemState.errorMessage)),
                    React.createElement(FocusZone_1.FocusZone, null,
                        React.createElement(Selection_1.SelectionZone, { onItemInvoked: this.onItemInvoked, selection: this.selection, selectionMode: Selection_1.SelectionMode.multiple },
                            React.createElement("div", { className: styles.listItemContainer, "data-is-scrollable": true },
                                React.createElement(List_1.List, { items: itemsWithKey, onRenderCell: this.renderListItem }))))),
                React.createElement(Button_1.PrimaryButton, { text: owa_options_strings_1.default.options_common_addButtonLabel, "data-is-focusable": true, disabled: !this.newItemState.value || this.newItemState.value.length === 0, onClick: this.onAddNewItemButtonClicked, className: styles.addNewItemButton }))));
    };
    EditSendersAndDomains.prototype.shouldSetFocusInEditListItemTextField = function () {
        // only set focus when initially displaying the text field and not
        // when there is an error message displayed - otherwise focus is trapped
        // in the text field when there is an error message
        return !this.editItemState.errorMessage;
    };
    EditSendersAndDomains.prototype.isDuplicate = function (text) {
        // Assume both local part and domain are case-insensitive
        var lowerCaseText = text.toLowerCase();
        return this.props.items.some(function (sender) { return sender.toLowerCase() === lowerCaseText; });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], EditSendersAndDomains.prototype, "editItemState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], EditSendersAndDomains.prototype, "newItemState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], EditSendersAndDomains.prototype, "selection", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onAddNewItemButtonClicked", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onEditItemTextFieldBlur", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "resetSelectionOnNextRender", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "resetSelection", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onEditItemTextFieldChanged", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onEditItemTextFieldKeyDown", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onEditListItemButtonClicked", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onDeleteListItemButtonClicked", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onItemInvoked", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "onNewItemTextFieldChanged", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "setEditItemTextFieldErrorMessage", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "setNewItemTextFieldErrorMessage", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "clearEditItemTextFieldErrorMessage", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EditSendersAndDomains.prototype, "clearNewItemTextFieldErrorMessage", void 0);
    EditSendersAndDomains = tslib_1.__decorate([
        mobx_react_1.observer
    ], EditSendersAndDomains);
    return EditSendersAndDomains;
}(React.Component));
exports.EditSendersAndDomains = EditSendersAndDomains;
//# sourceMappingURL=EditSendersAndDomains.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-mail-option-common/lib/components/EditSendersAndDomains.js
// module id = 5025
// module chunks = 2